import { Routes } from '@angular/router';
import { authGuard } from './core/guards/auth.guard';
import { guestGuard } from './core/guards/guest.guard';
import { permissionGuard } from './core/guards/permission.guard';
import { superAdminGuard } from './core/guards/super-admin.guard';
import { AdminLayoutComponent } from './layouts/admin-layout/admin-layout.component';
import { AuthLayoutComponent } from './layouts/auth-layout/auth-layout.component';

export const routes: Routes = [
  // Ruta pública — debe ir ANTES del bloque '' para que no la intercepte el authGuard
  {
    path: 'ayuda',
    loadComponent: () => import('./features/ayuda/ayuda.page').then(m => m.AyudaPage),
    data: { isPublic: true },
  },
  // Ruta pública — subdominio no registrado / suspendido (ver TenantService)
  {
    path: 'tenant-no-disponible',
    loadComponent: () => import('./features/tenant-no-disponible/tenant-no-disponible.page').then(m => m.TenantNoDisponiblePage),
    data: { isPublic: true },
  },
  {
    path: 'auth',
    component: AuthLayoutComponent,
    canActivate: [guestGuard],
    children: [
      {
        path: 'login',
        loadComponent: () => import('./features/auth/login/login.page').then(m => m.LoginPage)
      },
      {
        path: 'forgot-password',
        loadComponent: () => import('./features/auth/forgot-password/forgot-password.page').then(m => m.ForgotPasswordPage)
      },
      {
        path: 'request-access',
        loadComponent: () => import('./features/auth/request-access/request-access.page').then(m => m.RequestAccessPage)
      },
      { path: '', pathMatch: 'full', redirectTo: 'login' }
    ]
  },
  {
    path: '',
    component: AdminLayoutComponent,
    canActivate: [authGuard],
    children: [
      {
        path: 'dashboard',
        loadComponent: () => import('./features/dashboard/dashboard.page').then(m => m.DashboardPage)
      },
      {
        path: 'super-admin',
        canActivate: [superAdminGuard],
        loadChildren: () => import('./features/super-admin/super-admin.routes').then(m => m.SUPER_ADMIN_ROUTES),
      },
      {
        path: 'administracion',
        loadChildren: () => import('./features/administracion/administracion.routes').then(m => m.ADMINISTRACION_ROUTES)
      },
      {
        path: 'seguridad',
        loadChildren: () => import('./features/security/security.routes').then(m => m.SECURITY_ROUTES)
      },
      {
        path: 'crm',
        loadChildren: () => import('./features/crm/crm.routes').then(m => m.CRM_ROUTES)
      },
      {
        path: 'seguros',
        canActivate: [permissionGuard],
        data: { permission: 'SEGUROS' },
        loadChildren: () => import('./features/seguros/seguros.routes').then(m => m.SEGUROS_ROUTES)
      },
      {
        path: 'finanzas',
        loadChildren: () => import('./features/finanzas/finanzas.routes').then(m => m.FINANZAS_ROUTES)
      },
      {
        path: 'finanzas-basicas',
        loadChildren: () => import('./features/finanzas-basicas/finanzas-basicas.routes').then(m => m.FINANZAS_BASICAS_ROUTES)
      },
      {
        path: 'contabilidad',
        loadChildren: () => import('./features/contabilidad/contabilidad.routes').then(m => m.CONTABILIDAD_ROUTES)
      },
      {
        path: 'compras',
        loadChildren: () => import('./features/compras/compras.routes').then(m => m.COMPRAS_ROUTES)
      },
      {
        path: 'inventarios',
        loadChildren: () => import('./features/inventarios/inventarios.routes').then(m => m.INVENTARIOS_ROUTES)
      },
      {
        path: 'construccion',
        loadChildren: () => import('./features/construction/construction.routes').then(m => m.CONSTRUCCION_ROUTES)
      },
      {
        path: 'ventas',
        loadChildren: () => import('./features/sales/sales.routes').then(m => m.SALES_ROUTES)
      },
      {
        path: 'inmobiliaria',
        loadChildren: () => import('./features/inmobiliaria/inmobiliaria.routes').then(m => m.INMOBILIARIA_ROUTES)
      },
      {
        path: 'nomina',
        loadChildren: () => import('./features/nomina/nomina.routes').then(m => m.NOMINA_ROUTES)
      },
      {
        path: 'accesos',
        loadChildren: () => import('./features/accesos/accesos.routes').then(m => m.ACCESOS_ROUTES)
      },
      {
        path: 'postventa',
        loadChildren: () => import('./features/postventa/postventa.routes').then(m => m.POSTVENTA_ROUTES)
      },
      {
        path: 'repse',
        canActivate: [permissionGuard],
        data: { permission: 'REPSE' },
        loadChildren: () => import('./features/repse/repse.routes').then(m => m.REPSE_ROUTES),
      },
      {
        path: 'sst',
        canActivate: [permissionGuard],
        data: { permission: 'SST' },
        loadChildren: () => import('./features/sst/sst.routes').then(m => m.SST_ROUTES),
      },
      {
        path: 'drive',
        canActivate: [permissionGuard],
        data: { permission: 'DRIVE' },
        loadChildren: () => import('./features/drive/drive.routes').then(m => m.DRIVE_ROUTES),
      },
      {
        path: 'documentos',
        loadChildren: () => import('./features/documentos/documentos.routes').then(m => m.DOCUMENTOS_ROUTES)
      },
      {
        path: 'portal-clientes',
        loadChildren: () => import('./features/portal-clientes/portal-clientes.routes').then(m => m.PORTAL_CLIENTES_ROUTES)
      },
      {
        path: 'pagos',
        loadChildren: () => import('./features/pagos/pagos.routes').then(m => m.PAGOS_ROUTES)
      },
      {
        path: 'cadena-suministro',
        loadChildren: () => import('./features/cadena-suministro/cadena-suministro.routes').then(m => m.CADENA_SUMINISTRO_ROUTES)
      },
      {
        path: 'proyectos',
        loadChildren: () => import('./features/proyectos/proyectos.routes').then(m => m.PROYECTOS_ROUTES)
      },
      {
        path: 'precios-unitarios',
        loadChildren: () => import('./features/precios-unitarios/precios-unitarios.routes').then(m => m.PRECIOS_UNITARIOS_ROUTES)
      },
      {
        path: 'planeacion-recursos',
        loadChildren: () => import('./features/planeacion-recursos/planeacion-recursos.routes').then(m => m.PLANEACION_RECURSOS_ROUTES)
      },
      {
        path: 'activos-fijos',
        loadChildren: () => import('./features/activos-fijos/activos-fijos.routes').then(m => m.ACTIVOS_FIJOS_ROUTES)
      },
      {
        path: 'rh',
        loadChildren: () => import('./features/rh/rh.routes').then(m => m.RH_ROUTES)
      },
      {
        path: 'manufactura',
        loadChildren: () => import('./features/manufactura/manufactura.routes').then(m => m.MANUFACTURA_ROUTES)
      },
      {
        path: 'mantenimiento',
        loadChildren: () => import('./features/mantenimiento/mantenimiento.routes').then(m => m.MANTENIMIENTO_ROUTES)
      },
      {
        path: 'calidad',
        loadChildren: () => import('./features/calidad/calidad.routes').then(m => m.CALIDAD_ROUTES)
      },
      {
        path: 'pos',
        loadChildren: () => import('./features/pos/pos.routes').then(m => m.POS_ROUTES)
      },
      {
        path: 'ecommerce',
        loadChildren: () => import('./features/ecommerce/ecommerce.routes').then(m => m.ECOMMERCE_ROUTES)
      },
      {
        path: 'bi',
        loadChildren: () => import('./features/bi/bi.routes').then(m => m.BI_ROUTES)
      },
      {
        path: 'bsc',
        loadChildren: () => import('./features/bsc/bsc.routes').then(m => m.BSC_ROUTES)
      },
      {
        path: 'bim360',
        loadChildren: () => import('./features/bim360/bim360.routes').then(m => m.BIM360_ROUTES)
      },
      {
        path: 'workflow',
        loadChildren: () => import('./features/workflow/workflow.routes').then(m => m.WORKFLOW_ROUTES)
      },
      {
        path: 'integraciones',
        loadChildren: () => import('./features/integrations/integrations.routes').then(m => m.INTEGRATIONS_ROUTES)
      },
      {
        path: 'portales',
        loadChildren: () => import('./features/portales/portales.routes').then(m => m.PORTALES_ROUTES)
      },
      {
        path: 'whatsapp-agent',
        loadChildren: () => import('./features/whatsapp-agent/whatsapp-agent.routes').then(m => m.WHATSAPP_AGENT_ROUTES)
      },
      {
        path: 'bitacora',
        loadChildren: () => import('./features/bitacora/bitacora.routes').then(m => m.BITACORA_ROUTES)
      },
      {
        path: 'salud',
        loadChildren: () => import('./features/salud/salud.routes').then(m => m.SALUD_ROUTES),
      },
      {
        path: 'reportes',
        loadChildren: () => import('./features/reportes/reportes.routes').then(m => m.REPORTES_ROUTES),
      },
      {
        path: 'estacionamiento',
        loadChildren: () => import('./features/estacionamiento/estacionamiento.routes').then(m => m.ESTACIONAMIENTO_ROUTES),
      },
      {
        path: 'condominios',
        loadChildren: () => import('./features/condominios/condominios.routes').then(m => m.CONDOMINIOS_ROUTES),
      },
      {
        path: 'carrito',
        loadChildren: () => import('./features/carrito/carrito.routes').then(m => m.CARRITO_ROUTES),
      },
      {
        path: 'contratos',
        loadChildren: () => import('./features/contratos/contratos.routes').then(m => m.CONTRATOS_ROUTES),
      },
      {
        path: 'imss',
        loadChildren: () => import('./features/imss/imss.routes').then(m => m.IMSS_ROUTES),
      },
      {
        path: 'helpdesk',
        canActivate: [permissionGuard],
        data: { permission: 'HELPDESK' },
        loadChildren: () => import('./features/helpdesk/helpdesk.routes').then(m => m.HELPDESK_ROUTES),
      },
      {
        path: 'mailing',
        canActivate: [permissionGuard],
        data: { permission: 'MAILING' },
        loadChildren: () => import('./features/mailing/mailing.routes').then(m => m.MAILING_ROUTES),
      },
      {
        path: 'crud/:domain/:entity',
        loadComponent: () => import('./features/crud/crud-page/crud-page.component').then(m => m.CrudPageComponent)
      },
      { path: '', pathMatch: 'full', redirectTo: 'dashboard' }
    ]
  },
  {
    path: 'drive-publico/:token',
    loadComponent: () => import('./features/drive/drive-public/drive-public.page').then(m => m.DrivePublicPage),
    data: { isPublic: true },
  },
  {
    path: 'acceso-visitante/:token',
    loadComponent: () => import('./features/accesos/acceso-visitante.page').then(m => m.AccesoVisitantePage),
  },
  {
    path: 'pago-estacionamiento/:token',
    loadComponent: () => import('./features/pago-estacionamiento/pago-estacionamiento.page').then(m => m.PagoEstacionamientoPage),
  },
  {
    path: 'pago-recibo/:uuid',
    loadComponent: () => import('./features/pago-recibo-condo/pago-recibo-condo.page').then(m => m.PagoReciboCondo),
  },
  { path: '**', redirectTo: 'dashboard' }
];
